module.exports = __webpack_public_path__ + "media/assets/img/company/logo inshea-3f231668f73318d7cc18d40df10181b6.png";